// eslint-disable-next-line import/no-cycle
import router from '@/router';
import ContentApi from '@/api/content';
import { drafts } from '@/mixins/contentEditor';

const defaultState = () => ({
  contentItem: null,
  createContentLoading: false,
  contentItemLoading: false,
  saveContentLoading: false,
  deleteContentLoading: false,
  contentToEdit: null,
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setContentItemLoading(state, isLoading) {
      state.contentItemLoading = isLoading;
    },
    setContentItem(state, item) {
      state.contentItem = item;
    },
    updateContentItem(state, payload) {
      state.contentItem = Object.assign(state.contentItem, payload);
    },
    setSaveContentLoading(state, isLoading) {
      state.saveContentLoading = isLoading;
    },
    setDeleteContentLoading(state, isLoading) {
      state.deleteContentLoading = isLoading;
    },
    setCreateContentLoading(state, isLoading) {
      state.createContentLoading = isLoading;
    },
    setContentToEdit(state, payload) {
      state.contentToEdit = payload;
    },
    reset(state) {
      Object.assign(state, defaultState());
    },
  },
  actions: {
    async createContent({ commit, dispatch, rootGetters }, type) {
      try {
        commit('setCreateContentLoading', true);
        const { data } = await ContentApi.create(drafts[type]);
        commit('setContentItem', data);
        await router.push({
          name: `ftn.edit.${type}`,
          params: {
            id: data.id,
          },
        });

        commit('previewScreenWidgets/setWidgets', rootGetters['widgets/list'], { root: true });
        return data;
      } catch (e) {
        return dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setCreateContentLoading', false);
      }
    },
    async loadContentItem({ commit, dispatch }, id) {
      try {
        commit('setContentItemLoading', true);
        const { data } = await ContentApi.get(id);
        commit('setContentItem', data);
        return data;
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setContentItemLoading', false);
      }
    },
    async getContentItemToEdit({ commit, dispatch }, id) {
      try {
        const { data } = await ContentApi.findOneToEdit(id);
        commit('setContentItem', data);
        return data;
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        return router.push({ name: 'Homepage' });
      }
    },
    async saveContent({ commit, getters, dispatch }, { id, content }) {
      try {
        commit('setSaveContentLoading', true);
        await ContentApi.update(id, content);
        commit('setContentItem', { ...getters.contentItem, ...content });
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setSaveContentLoading', false);
      }
    },
    async deleteContent({ commit, dispatch }, id) {
      try {
        commit('setDeleteContentLoading', true);
        await ContentApi.delete(id);
        commit('setContentItem', null);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setDeleteContentLoading', false);
      }
    },
  },
  getters: {
    contentItem: state => state.contentItem || {},
    createContentLoading: state => state.createContentLoading,
    contentItemLoading: state => state.contentItemLoading,
    saveContentLoading: state => state.saveContentLoading,
    deleteContentLoading: state => state.deleteContentLoading,
    contentToEdit: state => state.contentToEdit,
  },
};
